/**
 * Shared sidebar CSS styles used by all layout components:
 * Dashboard, SupportDash, SalesLayout, TourAgentLayout
 */
export const sidebarStyles = `
  .main-sidebar {
    background-color: #55497C;
    color: #c0c2d7;
    z-index: 1000;
    position: relative;
    overflow: hidden;
  }

  .main-sidebar .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
  }

  /* Admin card — premium hero-style with gradient overlay */
  .main-sidebar .admin-card {
    padding: 20px 16px;
    margin-bottom: 0;
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: linear-gradient(135deg, rgba(107, 56, 239, 0.3) 0%, rgba(85, 73, 124, 0.6) 100%);
    border-bottom: 1px solid rgba(255,255,255,0.08);
  }

  .main-sidebar .admin-card .profile-pic-wrapper {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    overflow: hidden;
    flex-shrink: 0;
    border: 2px solid rgba(255, 255, 255, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #6B38EF;
    color: white;
    font-weight: bold;
    font-size: 1.1rem;
  }

  .main-sidebar .admin-card .profile-pic-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .main-sidebar .admin-card .admin-info span {
    color: #ffffff;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }

  .main-sidebar .admin-card .admin-info .admin-role {
    color: rgba(255,255,255,0.55);
    font-size: 0.72rem;
    font-weight: 500;
    letter-spacing: 0.02em;
  }

  /* Mobile sidebar header */
  .mobile-sidebar-header {
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    margin-bottom: 8px;
  }

  .mobile-sidebar-header .mobile-title {
    color: #ffffff;
    font-size: 1.1rem;
    font-weight: 600;
  }

  .mobile-sidebar-header .close-button {
    background: transparent;
    border: none;
    color: #c0c2d7;
    font-size: 1.2rem;
    cursor: pointer;
    transition: color 0.2s;
  }

  .mobile-sidebar-header .close-button:hover {
    color: #ffffff;
  }

  /* Menu */
  .main-sidebar .ant-menu {
    background: transparent !important;
    border-right: 0 !important;
    flex-grow: 1;
    padding: 8px 8px 0;
  }

  .main-sidebar .ant-menu-item,
  .main-sidebar .ant-menu-submenu-title {
    color: rgba(255,255,255,0.65) !important;
    margin-block: 2px !important;
    border-radius: 8px;
    background-color: transparent !important;
    transition: all 0.2s ease;
  }

  .main-sidebar .ant-menu-item > .ant-menu-item-icon,
  .main-sidebar .ant-menu-submenu-title > .ant-menu-item-icon,
  .main-sidebar .ant-menu-submenu-arrow {
    color: rgba(255,255,255,0.5) !important;
    transition: color 0.2s;
  }

  .main-sidebar .ant-menu-item:hover,
  .main-sidebar .ant-menu-submenu-title:hover {
    color: #ffffff !important;
    background-color: rgba(255,255,255,0.08) !important;
  }

  .main-sidebar .ant-menu-item:hover > .ant-menu-item-icon,
  .main-sidebar .ant-menu-submenu-title:hover > .ant-menu-item-icon,
  .main-sidebar .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow {
    color: #ffffff !important;
  }

  .main-sidebar .ant-menu-item-selected {
    background-color: rgba(255,255,255,0.12) !important;
    color: #ffffff !important;
    position: relative;
    font-weight: 600;
  }

  .main-sidebar .ant-menu-item-selected > .ant-menu-item-icon {
    color: var(--gh-teal, #1dc9b7) !important;
  }

  /* Selected indicator dot */
  .main-sidebar .ant-menu-item-selected::after {
    content: '';
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 6px;
    height: 6px;
    background-color: #1dc9b7;
    border-radius: 50%;
    display: block;
  }

  .main-sidebar .ant-menu-item:not(.ant-menu-item-selected)::after {
    display: none;
  }

  /* Submenus */
  .main-sidebar .ant-menu-sub.ant-menu-inline {
    background: transparent !important;
  }

  .main-sidebar .ant-menu-sub .ant-menu-item {
    padding-left: 48px !important;
    color: rgba(255,255,255,0.5) !important;
    background-color: transparent !important;
  }

  .main-sidebar .ant-menu-sub .ant-menu-item-selected {
    color: #ffffff !important;
    background-color: rgba(255,255,255,0.12) !important;
  }

  .main-sidebar .ant-menu-sub .ant-menu-item::before {
    content: '';
    position: absolute;
    left: 28px;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 4px;
    background-color: rgba(255,255,255,0.25);
    border-radius: 50%;
  }

  .main-sidebar .ant-menu-sub .ant-menu-item-selected::before {
    background-color: #1dc9b7;
  }

  /* Dividers */
  .main-sidebar .ant-menu-item-divider {
    margin: 0.75rem 16px !important;
    background-color: rgba(255, 255, 255, 0.1) !important;
    height: 1px !important;
    border: none;
  }

  /* Hide default trigger */
  .main-sidebar .ant-layout-sider-trigger {
    display: none;
  }

  /* Scrollbar styling */
  .main-sidebar::-webkit-scrollbar {
    width: 4px;
  }

  .main-sidebar::-webkit-scrollbar-track {
    background: transparent;
  }

  .main-sidebar::-webkit-scrollbar-thumb {
    background: rgba(255,255,255,0.15);
    border-radius: 4px;
  }
`;

export default sidebarStyles;
